module.exports = __webpack_public_path__ + "static/media/hospital2.c46ba78e.webp";